import { JsonObject, JsonProperty } from 'json2typescript';
import { OperativeContributionResponseInterface } from '../interfaces/contribution.response.interface';

@JsonObject('OperativeContributionResponse')
export class OperativeContributionResponse
  implements OperativeContributionResponseInterface
{
  @JsonProperty('ActivityId', String, true)
  activityId: string = undefined;

  @JsonProperty('CashAmount', Number, true)
  cashAmount: number = undefined;

  @JsonProperty('CashCurrency', String, true)
  cashCurrency: string = undefined;

  @JsonProperty('FundTransfers', String, true)
  fundTransfers: string = undefined;

  @JsonProperty('VerificationId', String, true)
  verificationId: string = undefined;

  @JsonProperty('Message', String, true)
  message: string = undefined;
}
